(function(){
  'use strict';
  var apiPromise=null;
  function api(){
    if(window.YT&&typeof window.YT.Player==='function')return Promise.resolve(window.YT);
    if(apiPromise)return apiPromise;
    apiPromise=new Promise(function(resolve,reject){
      var finished=false;var previous=window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady=function(){
        if(typeof previous==='function')try{previous();}catch(error){}
        if(finished)return;finished=true;
        if(window.YT&&typeof window.YT.Player==='function')resolve(window.YT);else reject(new Error('YouTube player API unavailable'));
      };
      if(!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')){
        var script=document.createElement('script');script.src='https://www.youtube.com/iframe_api';script.async=true;document.head.appendChild(script);
      }
      window.setTimeout(function(){if(!finished){finished=true;reject(new Error('YouTube player API timed out'));}},12000);
    });
    return apiPromise;
  }
  function setup(frame){
    if(frame.getAttribute('data-hp-video-ready')==='true')return;
    var shell=frame.closest('[data-hp-video-shell]');if(!shell)return;
    frame.setAttribute('data-hp-video-ready','true');
    var primary=frame.getAttribute('data-hp-youtube-primary');var backup=frame.getAttribute('data-hp-youtube-backup');var triedBackup=false;
    api().then(function(YT){
      var player=new YT.Player(frame,{events:{
        onReady:function(event){try{event.target.mute();event.target.playVideo();}catch(error){}},
        onError:function(event){
          if(!triedBackup&&backup&&backup!==primary){
            triedBackup=true;shell.classList.add('is-backup');
            try{event.target.loadVideoById(backup);event.target.mute();event.target.playVideo();return;}catch(error){}
          }
          shell.classList.add('is-failed');
        },
        onStateChange:function(event){if(event.data===YT.PlayerState.ENDED)try{event.target.seekTo(0,true);event.target.playVideo();}catch(error){}}
      }});shell._hpHeroPlayer=player;
    }).catch(function(){/* Keep the normal iframe and static image fallback when the API is blocked. */});
  }
  function init(){
    if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    document.querySelectorAll('[data-hp-hero-video]').forEach(setup);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
